export default __webpack_public_path__ + "static/media/WennieWu.d733b94b.png";